import React from "react";

export function ManageUsers() {
    return <div>
        Manage users
    </div>
}
